import { Route, Switch, Redirect } from 'react-router-dom';
import Login from './views/auth/login/login';
import Registration from './views/auth/registration/registration';
import BacSignup from './views/auth/bac-signup/bac-signup';
import { Container, Row } from 'shards-react';
// import Header from './views/auth/Header/Header';
import PasswordRecovery from './views/auth/password-recovery/password-recovery';
import ResetPassword from './views/auth/reset-password/reset-password';
import Home from './views/app/Home/Home';
import TermsAndConditions from './views/app/terms-and-conditions';
import Policy from './views/app/policy';
import Books from './views/app/Books/Books';
import Footer from './components/layouts/Footer/Footer';
import BookDetails from './views/app/BookDetails/BookDetails';
import ViewBook from './views/app/ViewBook/ViewBook';
import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import Header from './components/layouts/Header/Header';
import Sidebar from './components/layouts/Sidebar/Sidebar';
import Contact from './views/app/Contact/Contact';
import Theses from './views/visitor/Theses/Theses';
import ConferenceProceedings from './views/visitor/Publications/ConferenceProceedings';
import PublicationBooks from './views/visitor/Publications/PublicationBooks';
import Reports from './views/visitor/Publications/Reports';
import CouncilBooks from './views/visitor/Publications/CouncilBooks';
import CNERH from './views/visitor/Publications/CNERH';
import ElMadjlisHCI from './views/visitor/Publications/ElMadjlisHCI';
import BookPurchase from './views/visitor/BookPurchase/BookPurchase';
import PaymentSuccess from './views/visitor/PaymentSuccess/PaymentSuccess';
import TestPage from './views/visitor/TestPage/TestPage';
import AppDownload from './views/app/AppDownload/AppDownload';
const AuthRoutes = () => {
  const [openSidebar, setOpenSidebar] = useState(false);
  let location = useLocation();
  const [firstName, setFirstName] = useState('');
  return (
    <div className="auth-layout">
      {!location.pathname.includes('/view-book') && (
        <>
          <Header openSidebar={openSidebar} setOpenSidebar={setOpenSidebar} user={null} firstName={firstName} />
          <Sidebar openSidebar={openSidebar} setOpenSidebar={setOpenSidebar} user={null} />
        </>
      )}
      <main className="main-content">
        <Switch>
        {/* Visitor routes - accessible to non-authenticated users */}
        <Route exact path="/visitor/test" component={TestPage} />
        <Route exact path="/visitor/books" component={BookPurchase} />
        <Route exact path="/visitor/payment/success" component={PaymentSuccess} />
        
        {/* Public routes */}
        <Route exact path="/terms-of-service" component={TermsAndConditions} />
        <Route exact path="/" component={Home} />
        <Route path="/books" component={Books} />
        <Route exact path="/theses" component={Theses} />
        <Route exact path="/publications/conference-proceedings" component={ConferenceProceedings} />
        <Route exact path="/publications/books" component={PublicationBooks} />
        <Route exact path="/publications/reports" component={Reports} />
        <Route exact path="/publications/council-books" component={CouncilBooks} />
        <Route exact path="/publications/cnerh" component={CNERH} />
        <Route exact path="/publications/el-madjlis-hci" component={ElMadjlisHCI} />
        <Route exact path="/book-details/:id" component={BookDetails} />
        <Route exact path="/view-book/:id" render={(props) => <ViewBook {...props} user={null} />} />
        <Route exact path="/privacy" component={Policy} />
        <Route exact path="/contact" component={Contact} />
        <Route exact path="/app" component={AppDownload} />
        
        {/* Auth routes */}
        <Route path="/login">
          <Login />
        </Route>
        <Route exact path="/registration">
          <Registration />
        </Route>
        <Route exact path="/bac-signup">
          <BacSignup />
        </Route>
        <Route path="/password-recovery">
          <PasswordRecovery />
        </Route>
        <Route path="/reset-password" component={ResetPassword} />
        
        {/* Catch-all route - must be last */}
        <Route path="*">
          <Redirect to="/" />
        </Route>
        </Switch>
      </main>
      {!location.pathname.includes('/view-book') && (
        <>
          <Footer />
        </>
      )}
    </div>
  );
};

export default AuthRoutes;
